import React, { useEffect, useState } from 'react';
import { AuthSessionProvider } from './AuthSessionProvider';

export default function LayoutApp({ children }) {
  const [isShellOff, setIsShellOff] = useState(false);

  useEffect(() => {
    // Check if URL contains shell=off parameter
    const searchParams = new URLSearchParams(window.location.search);
    setIsShellOff(searchParams.get('shell') === 'off');
  }, []);

  if (isShellOff) {
    return <AuthSessionProvider>{children}</AuthSessionProvider>;
  }

  return (
    <AuthSessionProvider>
          {children}
    </AuthSessionProvider>
  );
}